import { Navigate } from "react-router-dom";

import jwtDecode from "jwt-decode";
import { IDecodedJwt } from "@/interfaces/jwtDecoded";

interface PrivateRouteProps {
  component: React.ReactNode;
}

export const AdminRoute = ({ component }: PrivateRouteProps) => {
  const token = localStorage.getItem("futToken");

  const decodedToken = token ? (jwtDecode(token) as IDecodedJwt) : undefined;

  if (!decodedToken?.isStaff) {
    return <Navigate to="/dashboard" replace />;
  }

  return component;
};
